import { render, staticRenderFns } from "./QuizOverview.vue?vue&type=template&id=d650dc24&scoped=true"
import script from "./QuizOverview.vue?vue&type=script&lang=js"
export * from "./QuizOverview.vue?vue&type=script&lang=js"
import style0 from "./QuizOverview.vue?vue&type=style&index=0&id=d650dc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d650dc24",
  null
  
)

export default component.exports